import { Dispatch, SetStateAction } from "react"

import { Form } from "react-bootstrap"

interface IncludeArchivedOrdersProps {
  value: boolean
  onChange: Dispatch<SetStateAction<boolean>>
}

function IncludeArchivedOrders(props: IncludeArchivedOrdersProps) {
  const { value, onChange } = props

  const onChangeIncludeArchived = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target
    onChange(checked)
  }

  return (
    <>
      <Form.Label htmlFor="include_archived" className="mr-3">
        Include Archived Orders
      </Form.Label>
      <Form.Check
        id="include_archived"
        type="checkbox"
        inline
        className="abc-checkbox abc-checkbox-inline"
        label=""
        value={value ? 1 : 0}
        checked={value}
        onChange={onChangeIncludeArchived}
      />
    </>
  )
}

export default IncludeArchivedOrders
